export default __webpack_public_path__ + "static/media/image-placeholder.de482f24.svg";